import React from "react";
import {
  Avatar,
  Divider,
  InfoViewCard,
  PageHeader,
  PageTitle,
} from "../../../../../../components";

const cardData = [
    {
      title: "Abhi Y",
      subtitle: "Confidential",
      description: "viewed confidential information on",
      timestamp: "04/04/2025 13:01:39",
    },
    {
      title: "Abhi Y",
      subtitle: "Work Authorization",
      description: "viewed confidential information on",
      timestamp: "05/04/2025 09:22:15",
    },
    {
      title: "Abhi Y",
      subtitle: "Confidential",
      description: "viewed confidential information on",
      timestamp: "06/04/2025 11:44:10",
    },
    {
      title: "Abhi Y",
      subtitle: "Work Authorization",
      description: "viewed confidential information on",
      timestamp: "06/04/2025 12:01:00",
    },
    {
      title: "Abhi Y",
      subtitle: "Confidential",
      description: "viewed confidential information on",
      timestamp: "07/04/2025 15:10:20",
    },
    {
      title: "Abhi Y",
      subtitle: "Work Authorization",
      description: "viewed confidential information on",
      timestamp: "08/04/2025 10:30:45",
    },
  ];
const Activity = () => {
  return (
    <div>
      <div>
        <PageHeader
          Section={
            <div className="flex ">
              <PageTitle title={"ACTIVITIES"} icon={"simulation"} tag="p" />
            </div>
          }
        />
        <Divider />
      </div>
      <div className="mt-6">
        {/* <div className="border-[1px] border-neutrals-50 rounded px-4 py-3 flex justify-between items-center">
          <div className="flex gap-3">
            <Avatar size="xl" />
            <div>
              <div className="flex items-center gap-3 ">
                <p> Abhi y</p>
                <span className="body-two text-neutral-400">Confidential</span>
              </div>
              <div>
                Abhi Y viewed confidential information on 04/04/2025 13:01:39
              </div>
            </div>
          </div>
          <div className="body-two text-neutral-400">04/04/2025 13:01:39</div>
        </div> */}
        {/* <InfoViewCard
          title="Abhi Y"
          subtitle="Confidential"
          description="viewed confidential information on"
          timestamp="04/04/2025 13:01:39"
        /> */}
        {cardData.map((item, index) => (
          <div className="mt-4">
            <InfoViewCard
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              description={`${item.title} ${item.description} ${item.timestamp}`}
              timestamp={item.timestamp}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Activity;
